import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { Palette, radius, spacing, useThemePalette } from '../theme';

interface SalaryProps {
  salary: string;
}

const Salary: React.FC<SalaryProps> = ({ salary }) => {
  const palette = useThemePalette();
  const styles = useMemo(() => makeStyles(palette), [palette]);
  return (
    <View style={styles.container}>
      <Text style={styles.salary}>{salary}</Text>
    </View>
  );
};

const makeStyles = (p: Palette) =>
  StyleSheet.create({
    container: {
      alignItems: 'flex-start',
      marginVertical: spacing.sm,
    },
    salary: {
      fontSize: 15,
      fontWeight: '700',
      color: p.appliedText,
      backgroundColor: p.appliedBg,
      paddingVertical: 6,
      paddingHorizontal: spacing.md,
      borderRadius: radius.sm,
    },
  });

export default Salary;
